import { cn } from '@/lib/utils'

export function ErrorCard({ children, className, ...rest }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('flex w-full flex-col items-center justify-center gap-1 px-4', className)} {...rest}>
      <img className="h-40 w-40" src="https://cdn.zhiyitech.cn/material/50344b19060357b04e957055c70eb233" />
      <span>{children}</span>
    </div>
  )
}
